export default "__VITE_ASSET__122803aa__"